import styled from "@emotion/styled";
import { Button } from "../../../button";

export const DatePickerCalendarButtonUrsa = styled(Button)`
    &:focus::before {
        inset: 0px;
        border-radius: 8px;
    }
`;
